/**
 * Where the *Sumáre* wallet warning goes when it is clicked - §9.451, FB-769.
 *
 * **The owner:** *"we have that information \"Peňažtenky nepokrývajú celú tržbu dňa\" make it, that
 * when wwe click on it, we can see which objednávka was it"* - then, with the figure: *"Bez
 * zamestnanca je 9,90 € - Hotovosť 9,90 €... when I cliccked on that, I dont see which order it
 * is"*.
 *
 * **The warning could not have been a link before `BACKEND.md` §10A.214.** `reconcile` subtracts two
 * **sums** - the day's total against the wallets' total - so it never knew which orders, and
 * `GET /orders` had no parameter that could be asked for them.
 *
 * **It goes to the archive rather than to a panel of its own**, because 1 to 8 orders a day is a
 * readable list and the archive already has the row detail, the assignment controls and the
 * per-order history somebody would want the moment they found one.
 *
 * **The day travels with it.** Without it the link would answer *every* unattributed order ever,
 * which is a different question from the one the warning asks and a much longer list.
 */
export function unattributedArchiveLink(day: string): string {
  const params = new URLSearchParams({ unattributed: 'true' })
  // Both bounds, because the archive reads `from` and `to` and a single-day window needs both:
  // with neither it sends `all_time=true` and the figure's day is lost.
  if (day) {
    params.set('from', day)
    params.set('to', day)
  }
  return `/lists?${params.toString()}`
}
